// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"ap-z","breadcrumbForward":"bp-z","breadcrumbBack":"cp-z","selected":"dp-z"};